/* No cart, tracking, network requests or dependencies. Reinitializes naturally in Theme Editor. */
if (!customElements.get('saitrio-air1')) {
  customElements.define('saitrio-air1', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      document.body.classList.add('saitrio-air1-page');
      const header = document.querySelector('.section-header') || document.querySelector('.sg-header-shell');
      if (header?.matches('.sg-header-shell')) header.classList.add('ap-header-standalone');
      this.headerScroll = () => header?.classList.toggle('ap-header-scrolled', window.scrollY > 80);
      window.addEventListener('scroll', this.headerScroll, { passive: true });
      this.headerScroll();
      const facts = this.querySelector('.ap-media-facts');
      if (facts) {
        this.factsObserver = new ResizeObserver(() => {
          this.style.setProperty('--ap-facts-offset', (facts.offsetHeight + parseFloat(getComputedStyle(facts).marginBottom)) + 'px');
        });
        this.factsObserver.observe(facts);
      }
      this.querySelectorAll('[data-gallery-step]').forEach(button => { button.hidden = false; });
      this.querySelector('[data-size-selector]')?.removeAttribute('hidden');
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) this.updatePurchase();
      });
      this.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
      this.addEventListener('click', (event) => {
        let button = event.target.closest('[data-gallery-target]');
        const step = event.target.closest('[data-gallery-step]');
        if (step && this.contains(step)) {
          const buttons = Array.from(this.querySelectorAll('[data-gallery-target]'));
          const current = buttons.findIndex(item => item.getAttribute('aria-pressed') === 'true');
          button = buttons[(current + Number(step.dataset.galleryStep) + buttons.length) % buttons.length];
        }
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryTarget; });
        this.querySelectorAll('[data-gallery-target]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
      this.updatePurchase();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.headerScroll);
      this.factsObserver?.disconnect();
      if (!document.querySelector('saitrio-air1')) document.body.classList.remove('saitrio-air1-page');
      this.initialized = false;
    }
    updatePurchase() {
      const selected = this.querySelector('input[type="radio"]:checked');
      if (!selected) return;
      const label = selected.dataset.label;
      this.querySelectorAll('[data-purchase-price]').forEach(node => { node.textContent = '$' + selected.dataset.price; });
      let destination = '';
      // Liquid has already checked offer state, listing scope and verification.
      // Recheck host here so a malformed editor value never becomes an active destination.
      try {
        const url = new URL(selected.dataset.url || '');
        if (url.protocol === 'https:' && ['www.amazon.com', 'amazon.com'].includes(url.hostname) && !url.username && !url.password) destination = url.href;
      } catch (_) { /* Missing mappings stay non-purchasable. */ }
      this.querySelectorAll('[data-amazon-link]').forEach((link) => {
        link.hidden = !destination;
        if (destination) {
          link.href = destination;
          link.setAttribute('aria-label', `${link.textContent.trim()} — ${label}`);
        } else link.removeAttribute('href');
      });
      this.querySelectorAll('[data-amazon-disabled]').forEach((button) => { button.hidden = !!destination; });
      this.querySelectorAll('[data-amazon-message]').forEach((message) => { message.hidden = !!destination; });
      this.querySelectorAll('[data-purchase-size]').forEach((node) => { node.textContent = label; });
      const status = this.querySelector('[data-size-status]');
      if (status) status.textContent = `${label} selected`;
    }
  });
}
